import { render, staticRenderFns } from "./SyncValues.vue?vue&type=template&id=4e32a876&scoped=true&"
import script from "./SyncValues.vue?vue&type=script&lang=js&"
export * from "./SyncValues.vue?vue&type=script&lang=js&"
import style0 from "./SyncValues.vue?vue&type=style&index=0&id=4e32a876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32a876",
  null
  
)

export default component.exports